import React from 'react';
import { AutoComplete, Button, Form, Icon, Select } from 'antd';
import PropTypes from 'prop-types';
import { getSubFormFieldByType, sanitizeFieldName } from '../../util/methods';
import ComplaintModal from "../ComplaintModal";
import DocumentList from "../../components/DocumentList";

class SubListPageSetting extends React.Component {

  id = 0;

  state = {
    keys: [],
  };

  componentDidMount() {
    const { data = [{}] } = this.props;
    this.setState({
      keys: data,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
      this.setState({
        keys: nextProps.data,
      });
    }
  }

  remove = (index, pindex = 0) => {
    // console.log(index, pindex)
    const { keys } = this.state;
    const { form, item } = this.props;
    const { field } = item;
    if (keys.length === 0) {
      return;
    }
    let val = form.getFieldValue(`settings`);
    console.log(val, field)

    // val = val[`${pindex}`][`${field}`];
    val.splice(index, 1);

    keys.splice(index, 1);
    for (let i = 0; i < val.length; i++) {
      Object.keys(item.schema).map((item, index) => {
        form.setFieldsValue({
          [`${field}[${i}][${item}]`]: val[i][item],
        });
      });
    }
    this.setState({
      keys: keys,
    });
  };

  add = () => {
    const { item: { field } } = this.props;
    const { keys } = this.state;
    keys.push(`${field}${this.id++}`);
    this.setState({
      keys: keys,
    });
  };

  render() {
    // console.log(this.props);
    const {
      form,
      item,
      data = [],
      hideAddButton = false,
      resource,
      superMaster,
      subMaster,
      selectData,
      pageData,
      isFromSetting = false
    } = this.props;
    const { field } = item;
    const { getFieldDecorator, setFieldsValue } = form;
    const { keys } = this.state;
    const style = {
      marginTop: '10px',
      border: '1px dashed #000',
      padding: '20px',
      borderRadius: '9px',
    };

    const formItems = keys.map((k, index) => (

      <div key={index} style={style}>
        {
          Object.keys(this.props.item.schema).map((fieldName, innerIndex) => {
            // console.log(item.schema[fieldName])
            // console.log(pageData, data[index]['name']);

            const nameSetting = data && data[index] && pageData && Object.keys(pageData).map(key => {
              if (key === data[index]['name'])
                return pageData[key];
            }).filter(s => s);
            // console.log(nameSetting)


            return getSubFormFieldByType(item.schema[fieldName], getFieldDecorator, data[index], `${index}${innerIndex}`, field, index, {
              title: 'CREATE',
              isFromSetting,
              resource,
              superMaster: (superMaster || false),
              subMaster: (subMaster || false),
              setFieldsValue,
              parent: this.props.parent,
              selectData: this.props.selectData,
              isSelectable: fieldName === 'name', //!!this.props.selectData
              valueType: nameSetting && nameSetting[0] && nameSetting[0]['type'],
            });
          })
        }

        {index >= 0 && !hideAddButton && !isFromSetting ? (
          <Icon
            className="dynamic-delete-button"
            type="minus-circle-o"
            onClick={() => this.remove(index, this.props.pindex)}
          />
        ) : null}
      </div>
    ));

    return (
      <div>
        {formItems}
        {
          this.props && this.props.hideAddButton ? <br /> : <Form.Item>
            <Button type="dashed" onClick={this.add} disabled={isFromSetting} style={{ width: '60%', marginTop: '15px' }}>
              <Icon type="plus" /> Add {sanitizeFieldName(item.field)}
            </Button>
          </Form.Item>
        }

      </div>

    );
  }
}

export default SubListPageSetting;
SubListPageSetting.defaultProps = {};

SubListPageSetting.propTypes = {
  item: PropTypes.object,
};
